import { Tooltip } from "@mui/material";
import { ReactNode, useLayoutEffect, useRef, useState } from "react";
import { TooltipProps } from "@mui/material/Tooltip/Tooltip";

// CCK also has such a component, but it is not exported
const OverflowTooltip = ({ children, ...rest }: {
	children: ReactNode;
	title?: ReactNode;
} & Omit<TooltipProps, "title" | "children" | "disableHoverListener">) => {
	const labelRef = useRef<HTMLSpanElement>(null);
	const [ isOverflowing, setIsOverflowing ] = useState(false);

	useLayoutEffect(() => {
		const labelElement = labelRef.current;
		if (!labelElement) {
			return;
		}

		const check = () => setIsOverflowing(labelElement.scrollWidth > labelElement.clientWidth);
		check();

		const observer = new ResizeObserver(check);
		observer.observe(labelElement);

		return () => observer.disconnect();
	}, [ children ]);

	return (
		<Tooltip
			title={<span style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{children}</span>}
			{...rest}
			disableHoverListener={!isOverflowing}
		>
			<span
				ref={labelRef}
				style={{
					display: "block",
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
				}}
			>
				{children}
			</span>
		</Tooltip>
	);
};

export default OverflowTooltip;
